import type { Bucket } from "../../shared/price.ts";
import { useT } from "../lib/i18n.tsx";

const stateByBucket = {
  days: "far",
  under_day: "far",
  hours: "near",
  ending_soon: "ending",
} as const;

/** Label from the bucket; key on the bucket so a change cross-fades (CSS). */
export function TimeBucket({ bucket }: { bucket: Bucket }) {
  const t = useT();
  return (
    <span key={bucket} className={`bucket bucket--${stateByBucket[bucket]}`}>
      {t(`bucket.${bucket}`)}
    </span>
  );
}
